
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/a-philosophy-of-software-design",
      function () {
        return require("private-next-pages/books/a-philosophy-of-software-design.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/a-philosophy-of-software-design"])
      });
    }
  